import script from "./SelectDropDownV2.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectDropDownV2.vue?vue&type=script&setup=true&lang=js"

import "./SelectDropDownV2.vue?vue&type=style&index=0&id=6babf8b9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6babf8b9"]])

export default __exports__